import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import Reveal from '../components/ui/Reveal';
import { modules, apps } from '../data/modules';
import './Platform.css';

export default function Platform() {
  return (
    <div className="platform-page">
      <PageHero
        eyebrow="The Platform"
        title="Seven modules. Two apps. One connected system."
        body="Everything a field-service or maintenance business needs to run — booking, dispatch, customer records, inventory, billing, and recurring contracts — built to work together instead of as separate tools."
      />

      <section className="section">
        <div className="container">
          <div className="modules-list">
            {modules.map((mod, i) => (
              <Reveal key={mod.id} className={`module-row ${i % 2 === 1 ? 'reverse' : ''}`}>
                <div className="module-row-visual">
                  <span className="module-row-icon"><mod.icon size={48} strokeWidth={1.4} /></span>
                </div>
                <div className="module-row-copy">
                  <span className="eyebrow">{mod.name}</span>
                  <h2>{mod.summary}</h2>
                  <ul>
                    {mod.points.map((p) => (
                      <li key={p}>{p}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <Reveal className="section-head center">
            <span className="eyebrow">Companion Apps</span>
            <h2>The platform doesn’t stop at the office dashboard.</h2>
            <p>Two purpose-built apps extend the same system to the people doing the work and the people paying for it.</p>
          </Reveal>

          <div className="apps-grid">
            {apps.map((app, i) => (
              <Reveal key={app.id} className={`app-card card ${i === 1 ? 'app-card-alt' : ''}`}>
                <span className="pill">{app.audience}</span>
                <h3>{app.name}</h3>
                <p className="app-tagline">{app.tagline}</p>
                <p>{app.description}</p>
                <ul className="app-points">
                  {app.points.map((pt) => (
                    <li key={pt}>{pt}</li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container">
          <Reveal className="cta-box card">
            <h2>Ready to see it running on your workflow?</h2>
            <p>Book a walkthrough and we’ll configure the modules around how your team already works.</p>
            <div className="hero-actions center">
              <Link to="/contact" className="btn btn-primary">Book a Demo</Link>
              <Link to="/industries" className="btn btn-secondary">See it by industry</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
